import { ComponentRef, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark";
import { faCloudArrowDown } from "@fortawesome/free-solid-svg-icons/faCloudArrowDown";

import { useDownloadFiles } from "../../../data/files/downloadFiles/useDownloadFiles";

export const ImageModal = ({ asset, onClose }: { asset: { path: string; name: string }; onClose?: () => void }) => {
  const dialogRef = useRef<ComponentRef<"dialog">>(null);
  const { mutate: downloadFiles } = useDownloadFiles();

  useEffect(() => {
    dialogRef.current?.showModal();
  }, []);

  return (
    <dialog
      onClose={onClose}
      ref={dialogRef}
      className="relative box-border h-screen max-h-none w-full max-w-none border-0 bg-transparent opacity-0 transition-opacity backdrop:bg-canvas-100/70 backdrop:backdrop-blur open:opacity-100"
    >
      <button className="absolute right-4 top-6 cursor-pointer border-0 bg-transparent" onClick={onClose}>
        <FontAwesomeIcon className="text-5xl text-white/50 hover:text-white" icon={faXmark} />
      </button>
      <button
        className="absolute bottom-6 left-1/2 -translate-x-1/2 cursor-pointer border-0 bg-transparent"
        onClick={() => {
          downloadFiles({ url: asset.path, name: asset.name });
        }}
      >
        <FontAwesomeIcon className="text-5xl text-white/50 hover:text-white" icon={faCloudArrowDown} />
      </button>
      <div className="flex size-full items-center justify-center px-4 py-8">
        <img className="max-h-full w-auto" src={asset.path} alt="" />
      </div>
    </dialog>
  );
};
